import type { RouteObject } from 'react-router';

import * as salaryReportHorizonRouteExports from '#/modules/salary/pages/explore/SalaryExplore.horizon-route';
import * as compensationSurveyHorizonRouteExports from '#/modules/salary/pages/survey/SalarySurvey.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { salariesExploreRoute, salariesSurveyRoute } from './salary.routes';

export const salaryRouteObjects = [
  {
    path: salariesExploreRoute.fullPath,
    ...horizonRouteToObject(salaryReportHorizonRouteExports),
  },
  {
    path: salariesSurveyRoute.fullPath,
    ...horizonRouteToObject(compensationSurveyHorizonRouteExports),
  },
] satisfies RouteObject[];
